var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6023 5.55337C11.2352 4.49784 12.7648 4.49783 13.3977 5.55337L20.0468 16.6435C20.698 17.7297 19.9156 19.1111 18.6491 19.1111H5.35087C4.0844 19.1111 3.30196 17.7297 3.95319 16.6435L10.6023 5.55337Z",
    fill: "#F34D57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7953 4.71538L21.4445 15.8055C22.747 17.9779 21.1821 20.7407 18.6491 20.7407H5.35087C2.81794 20.7407 1.25306 17.9779 2.55553 15.8055L9.20467 4.71538C10.4704 2.60432 13.5296 2.60431 14.7953 4.71538ZM13.3977 5.55336C12.7648 4.49783 11.2352 4.49783 10.6023 5.55336L3.9532 16.6435C3.30196 17.7297 4.0844 19.1111 5.35087 19.1111H18.6491C19.9156 19.1111 20.698 17.7297 20.0468 16.6435L13.3977 5.55336Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9417 14.009C12.4641 14.009 12.733 13.6986 12.7486 13.1659L12.8417 9.9488C12.8468 9.86605 12.852 9.77295 12.852 9.70571C12.852 9.1316 12.5158 8.79541 11.9469 8.79541C11.3728 8.79541 11.0314 9.1316 11.0314 9.70571C11.0314 9.77295 11.0366 9.86605 11.0366 9.9488L11.1348 13.1659C11.1504 13.6986 11.4141 14.009 11.9417 14.009ZM11.9417 16.5485C12.4796 16.5485 12.9192 16.1399 12.9192 15.6175C12.9192 15.1003 12.4796 14.6917 11.9417 14.6917C11.3986 14.6917 10.959 15.1003 10.959 15.6175C10.959 16.1399 11.3986 16.5485 11.9417 16.5485Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.6e51e7a7ba9660886d2335dd12a324e4.svg";
export { ForwardRef as ReactComponent };